import "./App.css";
import { useMemo } from "react";

import Minter from "./Minter";

import magiceden from './images/magiceden_logo224.png'

import * as anchor from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSolflareWallet,
  getSolletWallet,
  getMathWallet,
} from "@solana/wallet-adapter-wallets";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";

import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { ThemeProvider, createTheme } from "@material-ui/core";


const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const candyMachineId = process.env.REACT_APP_CANDY_MACHINE_ID
  ? new anchor.web3.PublicKey(process.env.REACT_APP_CANDY_MACHINE_ID)
  : undefined;

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [getPhantomWallet(), getSolflareWallet(), getSolletWallet(), getMathWallet() ],
    []
  );

  function toggleMenu() {
    const menu = document.getElementById("mobileNavContainer")!;
    menu.classList.toggle("open-menu");
    console.log("pressed");
  }

  return (
    <div>
      <div id="mobileNavContainer" className="mobile-nav">
        <div className="mobile-nav-close-button" >
          <img src="/icons/close.svg" alt="" onClick={toggleMenu}/>
        </div>
        <ul>
          <li>
            <img className="mobile-nav-logo" src="/img/logo.png" alt="" />
          </li>
          <li>
            <div className="social-icons">
            <a href="https://twitter.com/SolApeLarva">
              <img className="nav-social" src="/icons/twitter.svg" alt="" />
            </a>
            <a href="https://discord.gg/D3CTYCCHyH">
              <img className="nav-social" src="/icons/discord.svg" alt="" />
            </a>
            </div>
          </li>
        </ul>
      </div>
      <div className="mobile-menu-button" onClick={toggleMenu}>
        <img src="/icons/menu.svg" alt="" />
      </div>
      <nav>
        <div className="nav-container">
          <img className="nav-logo" src="/img/logo.png" alt="" />
          <div className="social-icons hide-800">
          <a href="https://twitter.com/SolApeLarva">
            <img className="nav-social" src="/icons/twitter.svg" alt="" />
          </a>
          <a href="https://discord.gg/D3CTYCCHyH">
            <img className="nav-social" src="/icons/discord.svg" alt="" />
          </a>
          </div>
        </div>
      </nav>
      <div className="content-wrapper">
          <header className="card" id="link1">
            <div style={{ padding: "0 24px 0 24px 0" }}>
              <h3 className="text-secondary-color">Welcome to</h3>
              <h1 className="pb-3">the Sol Ape Larva Club</h1>
              <p className="text-secondary-color">
                555 uniquely generated Ape Larvas are joining the Solana Ecosystem. Don't miss out! Grab one of them before it's too late!
              </p>
            </div>
            <div>
              <ThemeProvider theme={theme}>
                <ConnectionProvider endpoint={endpoint}>
                  <WalletProvider wallets={wallets} autoConnect>
                    <WalletDialogProvider>
                      
                        <Minter
                          candyMachineId={candyMachineId}
                          
                          connection={connection}
                          startDate={startDateSeed}
                          txTimeout={txTimeout}
                          rpcHost={rpcHost}
                        />
                      
                    </WalletDialogProvider>
                  </WalletProvider>
                </ConnectionProvider>
              </ThemeProvider>
            </div>
          </header>
      
          <div id="link3" className="container card">
            <h1 className="pb-3">Marketplaces</h1>
            We will apply for the following marketplaces once all of our collection has been minted.
            <div id="marketplace-images" className="marketplace-image-container">
            <a href="https://salc.netlify.app">
              <img src={magiceden} alt=""/>
            </a>
            </div>
          </div>

          <div id="link4" className="container faq">
            <h1 style={{ padding: "0 0 24px 0" }}>FAQ</h1>
            <div>
              <h4>How do I connect my wallet?</h4>
              <p>
                Just press the 'Connect' button in the upper section of our website.
                Select your wallet provider and enter your wallet credentials. Thats it, now you can mint!
              </p>

              <hr />
            </div>

            <div>
              <h4>I cannot mint, what should I do?</h4>
              <p>
                This could have multiple reasons. Please refresh our website once the presale has started.
                You could also check if your solana balance is sufficient and that you're connected with the correct wallet.
              </p>

              <hr />
            </div>

            <div>
              <h4>Transaction has failed, what should I do?</h4>
              <p>
                Solana network traffic might cause some delays in our release time, in that case you just gotta wait a few seconds or minutes and keep retrying.
              </p>

              <hr />
            </div>

            <div>
              <h4>Where do I get more information about you guys?</h4>
              <p>
                For more information please check out our social media accounts and our discord, we keep you up to date in there!
              </p>

              <hr />
            </div>
          </div>
      </div>
    </div>
  );
};

export default App;
